import { Component, Ref, SimpleEvent } from '@eastsideco/salvo-ts';
import { ThemeComponent } from "@/theme/ThemeComponent";
import { CartMain } from '../Cart/CartMain';
import { cart } from "@/theme/Cart";

@Component
export class SideCart extends ThemeComponent {
    @Ref({required: false}) count!: HTMLElement;
    @Ref cartMain!: CartMain;

    private _onOpenChange = new SimpleEvent<string>();
    public get onOpenChange() {
        return this._onOpenChange.asEvent();
    }

    /**
     * Initialise.
     */
    init() {
        this.$subscribe(this.cartMain.onCartItemCountChange, this.setCount.bind(this));
        this.eventListeners();
    }

    /**
     * Event Listeners
     */
    eventListeners() {
        this.openCart();
    }

    /**
     * Open Side Cart.
     */
    openCart() {
        document.addEventListener('cartOpen', ()=> {
            this._onOpenChange.dispatch('');
        });
    }
    private setCount(item: number) {
        const countSpan = this.parentElement?.querySelector('[data-ref="count"]');
        if(!countSpan) { return; }
        countSpan.innerHTML = String(item);
    }
}
